import { Message } from './message'
import type { PendingClarification } from './types'

/** 추가 확인이 필요한 변경 입력에 대해 질문 목록을 표시한다. */
export function ClarificationMessages({
    pendingClarification,
}: {
    pendingClarification: PendingClarification
}) {
    return (
        <>
            <Message from='user'>
                <p className='whitespace-pre-wrap'>
                    {pendingClarification.original}
                </p>
            </Message>
            <Message from='bot'>
                <div className='grid gap-2'>
                    <p>
                        정확한 영향 항목을 고르기 위해 몇 가지만 더 확인할게요.
                    </p>
                    {pendingClarification.refinedDescription ? (
                        <p className='text-muted-foreground text-sm'>
                            이렇게 이해했어요:{' '}
                            {pendingClarification.refinedDescription}
                        </p>
                    ) : null}
                    {pendingClarification.reason ? (
                        <p className='text-muted-foreground text-sm'>
                            {pendingClarification.reason}
                        </p>
                    ) : null}
                    <p className='text-foreground text-sm'>
                        아래에서 질문에 하나씩 답해 주세요. 예시를 누르거나 직접
                        입력할 수 있어요.
                    </p>
                </div>
            </Message>
        </>
    )
}
